import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { AppConfigService } from '../../services/app-config.service';
import { map, tap } from 'rxjs/operators';
import { Gestionnaire } from '../../models/gestionnaire';
import { Observable } from 'rxjs';
import { FichePatient } from './FichePatient.model';


export interface SearchElement {
  nom: string;
  prenom: string;
  numeroSS: string;
  telPatient: string;
  codeMedecin: string;
  numeroOrdonnance: number;
  dateOrdonnanceDu: string;
  dateOrdonnanceAu: string;
  dateDepotDu: string;
  dateDepotAu: string;
  dateImpression: string;
  heureImpression: string;
  avecPatientSansDocument: Boolean;
  avecDocumentTraite: Boolean;
  uniquementErreurGed: Boolean;
  numColTri: number; // numéro de la colonne à trié
  limit: number; // nombre de ligne dans une page
  pageOffset: number; // décalage de page
  directionTri: string; // asc ou desc
  gestionnaireKey: number; // gestionnaire de la demande
}

export interface ProcessDocument {
  documentKey: number;
  gestionnaireKey: number;
  process: boolean;
}


@Injectable({
  providedIn: 'root'
})
export class GestionnaireService {
  private apiUrl: string;

  constructor(private _http: HttpClient, private _appConfig: AppConfigService) {
      this.apiUrl = _appConfig.config.servicesBaseUrl;
  }

  search(searchInfo: SearchElement) {
    return this._http.post<any>(this.apiUrl + `/bo/search`, searchInfo)
        .pipe(map(c => {
            return c;
        }));
  }

  exportExcel(searchInfo: SearchElement)  {
    return this._http.post<any>( this.apiUrl + `/bo/export/search`, searchInfo,
        {
          responseType: 'blob' as 'json',
          observe: 'response'
        });
  }

  markAsTreated(searchInfo: SearchElement) {
    return this._http.post<any>( this.apiUrl + `/bo/search/mark-as-treated`, searchInfo)
    .pipe(map(c => {
      return c;
        }));
  }

  getConfigResponse(): Observable<HttpResponse<any>> {
    return this._http.get<any>(
      this.apiUrl, { observe: 'response' });
  }

  process(processDocument: ProcessDocument) {
    return this._http.post<any>(this.apiUrl + `/bo/process`, processDocument)
        .pipe(map(c => {
            return c;
        }));
  }

  getGestionnaireByCptKey(compteKey: string) {
    return this._http.get<Gestionnaire[]>(this.apiUrl + `/bo/ges/cpt/` + compteKey)
        .pipe(map(ges => {
            return ges;
        }));
  }

  resetGed(documentKey: number) {
    return this._http.put(this.apiUrl + '/bo/reset-document-ged/' + documentKey, { reset: true });
  }

  getFichePatient(patientKey: number): Observable<FichePatient> {
    return this._http.get<FichePatient>(this.apiUrl + '/bo/fiche-patient/' + patientKey);
  }

  sendBackEmail(patientKey: number) {
    return this._http.put<FichePatient>(this.apiUrl + '/bo/send-back-email/' + patientKey, null);
  }

}
